import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { InstutionFunction } from './instution-function.model';
import * as InstutionFunctionActions from './instution-function.actions';

export const instutionFunctionsFeatureKey = 'instutionFunctions';

export interface State extends EntityState<InstutionFunction> {
  // additional entities state properties
}

export const adapter: EntityAdapter<InstutionFunction> = createEntityAdapter<InstutionFunction>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(InstutionFunctionActions.addInstutionFunction,
    (state, action) => adapter.addOne(action.instutionFunction, state)
  ),
  on(InstutionFunctionActions.upsertInstutionFunction,
    (state, action) => adapter.upsertOne(action.instutionFunction, state)
  ),
  on(InstutionFunctionActions.addInstutionFunctions,
    (state, action) => adapter.addMany(action.instutionFunctions, state)
  ),
  on(InstutionFunctionActions.upsertInstutionFunctions,
    (state, action) => adapter.upsertMany(action.instutionFunctions, state)
  ),
  on(InstutionFunctionActions.updateInstutionFunction,
    (state, action) => adapter.updateOne(action.instutionFunction, state)
  ),
  on(InstutionFunctionActions.updateInstutionFunctions,
    (state, action) => adapter.updateMany(action.instutionFunctions, state)
  ),
  on(InstutionFunctionActions.deleteInstutionFunction,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(InstutionFunctionActions.deleteInstutionFunctions,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(InstutionFunctionActions.loadInstutionFunctions,
    (state, action) => adapter.setAll(action.instutionFunctions, state)
  ),
  on(InstutionFunctionActions.clearInstutionFunctions,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
